import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonButtonLink } from './ButtonLink.definition';
import { chameleonSvg } from '../Svg';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonButtonLink({ prefix }), chameleonSvg({ prefix }));
}
